import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { MeetingStatus } from '../types';
import { COLORS } from '../theme/designSystem';

interface Props {
  status: MeetingStatus | string;
}

export const StatusBadge: React.FC<Props> = ({ status }) => {
  const getBadgeStyle = () => {
    switch (status) {
      case MeetingStatus.CONFIRMED:
      case MeetingStatus.APPROVED:
        return {
          bg: COLORS.successBg,
          borderColor: COLORS.success,
          text: COLORS.success,
          label: 'CONFIRMED',
          dot: COLORS.success,
        };
      case MeetingStatus.PENDING:
        return {
          bg: COLORS.warningBg,
          borderColor: COLORS.warning,
          text: COLORS.warning,
          label: 'PENDING APPROVAL',
          dot: COLORS.warning,
        };
      case MeetingStatus.REJECTED:
        return {
          bg: COLORS.dangerBg,
          borderColor: COLORS.danger,
          text: COLORS.danger,
          label: 'REJECTED',
          dot: COLORS.danger,
        };
      default:
        return {
          bg: 'rgba(148, 163, 184, 0.15)',
          borderColor: '#94A3B8',
          text: '#94A3B8',
          label: String(status),
          dot: '#94A3B8',
        };
    }
  };

  const config = getBadgeStyle();

  return (
    <View
      style={[
        styles.badge,
        {
          backgroundColor: config.bg,
          borderColor: config.borderColor,
        },
      ]}
    >
      <View style={[styles.dot, { backgroundColor: config.dot }]} />
      <Text style={[styles.text, { color: config.text }]}>{config.label}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  badge: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 20,
    borderWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    marginRight: 6,
  },
  text: {
    fontSize: 10,
    fontWeight: '800',
    letterSpacing: 0.5,
  },
});
